import { MoveNormalized } from '@/modules/move/entities/interfaces/move';
import { ExportMoveRowsFilters } from '@/modules/move/entities/interfaces/moveRow';
import { MoveRowService } from '@/modules/move/services/moveRowService';
import { downloadFileLink } from '@/utils/common';
import { tryOrCatchMessageError } from '@/utils/tryOrCatchMessageError';
import { useCallback, useState } from 'react';

interface UseExportMoveRows {
  move?: MoveNormalized;
}

export const useExportMoveRows = ({ move }: UseExportMoveRows) => {
  const [loading, setLoading] = useState<boolean>(false);

  const downloadRows = useCallback(
    async (filters: Partial<ExportMoveRowsFilters>) => {
      return tryOrCatchMessageError(
        async () => {
          if (!move) {
            return;
          }

          const file = await new MoveRowService().exportRows(filters);
          const filenamePrefix = 'beneficiarios-concluidos-';
          const filename = `${filenamePrefix}${move.name}`;
          const url = URL.createObjectURL(new Blob([file]));

          downloadFileLink(url, filename);
        },
        {
          messageErrorDefault: 'Erro no download da planilha de beneficiários.',
          tryBefore: () => setLoading(true),
          tryAfter: () => setLoading(false),
        },
      );
    },
    [move],
  );

  return {
    loading,
    downloadRows,
  };
};
